import { render, staticRenderFns } from "./billInfo.vue?vue&type=template&id=4a45351a&scoped=true"
import script from "./billInfo.vue?vue&type=script&lang=js"
export * from "./billInfo.vue?vue&type=script&lang=js"
import style0 from "./billInfo.vue?vue&type=style&index=0&id=4a45351a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45351a",
  null
  
)

export default component.exports